import React from "react";
import { classes } from "typestyle";
import * as styles from "./styles";

type SpinnerProps = {
  size?: keyof styles.SpinnerSizes;
  theme?: "black" | "white";
};

const Spinner: React.FC<SpinnerProps> = ({ size = "normal", theme = "black" }) => (
  <div className={classes(styles.spinner, styles.sizes[size], styles.themes[theme])} />
);

export const FullscreenSpinner: React.FC = () => (
  <div
    style={{
      width: "100%",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Spinner size="large" />
  </div>
);

export const SpinnerContainer: React.FC<{ height: number }> = ({ height }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height }}>
    <Spinner size="large" />
  </div>
);

export default Spinner;
